import { toast } from "react-toastify";
// src/pages/admin/LabourManagementPage.js
import React, { useEffect, useMemo, useState } from "react";
import labourLogService from "../../shared/api/labourLogService"; // DO NOT CHANGE

// --- STYLES (Specific to this page) ---
const Styles = () => (
  <style>{`
    .labour-page { color:#17261f; padding:1.25rem 0 2rem; }
    .labour-page .page-header { display:flex; gap:1rem; flex-wrap:wrap; justify-content:space-between; align-items:flex-start; margin-bottom:1.25rem; }
    .labour-page .page-title { margin:0; font-size:2rem; line-height:1.2; font-weight:800; letter-spacing:-.03em; color:#13261d; }
    .labour-page .btn { min-height:42px; padding:.62rem 1rem; border-radius:10px; font-weight:700; transition:all .18s ease; font-size:.9rem; border:1px solid #cbd9d2; cursor:pointer; background:#fff; color:#29453a; box-shadow:0 1px 2px rgba(18,56,42,.05); }
    .labour-page .btn:hover:not(:disabled) { border-color:#168663; transform:translateY(-1px); box-shadow:0 5px 14px rgba(18,86,62,.1); }
    .labour-page .btn:disabled { opacity:.5; cursor:not-allowed; }
    .labour-page .btn-primary { background:#13835f; color:#fff; border-color:#13835f; }
    .labour-page .btn-primary:hover:not(:disabled) { background:#0f6d50; }
    .labour-page .btn-ghost { background:#f7faf8; color:#29453a; }
    .labour-page .btn-danger { background:#fff5f5; border-color:#fecaca; color:#b42318; }
    .labour-page .btn-danger:hover:not(:disabled) { background:#feecec; border-color:#f87171; }
    .labour-page .btn-small { min-height:34px; padding:.4rem .7rem; font-size:.8rem; border-radius:8px; }
    .labour-page .cards { display:grid; grid-template-columns:minmax(210px,.8fr) minmax(300px,1.15fr) minmax(320px,1.35fr); gap:1rem; margin-bottom:1rem; align-items:stretch; }
    .labour-page .card, .labour-page .chart-wrap { background:#fff; border:1px solid #dce7e1; border-radius:16px; padding:1.15rem; color:#17261f; box-shadow:0 8px 24px rgba(23,54,42,.05); }
    .labour-page .kpi { margin-top:.55rem; font-size:1.9rem; font-weight:800; color:#11694f; }
    .labour-page .muted { color:#72867d; font-size:.84rem; }
    .labour-page .filters { background:#fff; border:1px solid #dce7e1; border-radius:16px; padding:1rem; margin-bottom:1rem; display:grid; grid-template-columns:repeat(6,minmax(140px,1fr)); gap:.75rem; box-shadow:0 8px 24px rgba(23,54,42,.04); }
    .labour-page .input, .labour-page .select { width:100%; min-height:44px; box-sizing:border-box; padding:.65rem .75rem; border-radius:10px; border:1px solid #cbd9d2; background:#fff; color:#17261f; outline:none; }
    .labour-page .input:focus, .labour-page .select:focus { border-color:#168663; box-shadow:0 0 0 3px rgba(22,134,99,.12); }
    .labour-page .table-container { background:#fff; border-radius:16px; border:1px solid #dce7e1; overflow-x:auto; box-shadow:0 8px 24px rgba(23,54,42,.05); }
    .labour-page .labour-table { width:100%; border-collapse:collapse; }
    .labour-page .labour-table th, .labour-page .labour-table td { padding:.9rem 1rem; text-align:left; border-bottom:1px solid #e8efeb; white-space:nowrap; vertical-align:top; }
    .labour-page .labour-table th { background:#f4f8f6; font-size:.72rem; text-transform:uppercase; letter-spacing:.055em; color:#60756b; }
    .labour-page .labour-table td { font-weight:500; color:#294038; }
    .labour-page .labour-table tbody tr:hover { background:#fbfdfc; }
    .labour-page .error-message { color:#a61b1b; background:#fff1f1; border:1px solid #fecaca; padding:.85rem 1rem; border-radius:10px; margin-bottom:1rem; }
    .labour-page .actions { display:flex; gap:.55rem; flex-wrap:wrap; }
    .labour-page .chart-wrap { min-width:0; overflow:hidden; }
    .labour-page .chart-title { font-size:.95rem; font-weight:700; color:#29453a; margin-bottom:.25rem; display:flex; gap:.65rem; align-items:center; }
    .labour-page .legend { display:flex; gap:.75rem; font-size:.78rem; font-weight:500; color:#72867d; }
    .labour-page .legend span { display:inline-flex; align-items:center; gap:.35rem; }
    .labour-page .dot { width:9px; height:9px; border-radius:3px; display:inline-block; background:#168663; }
    .labour-page .modal-overlay { position:fixed; inset:0; background:rgba(14,31,24,.55); backdrop-filter:blur(3px); display:flex; align-items:center; justify-content:center; z-index:1001; padding:1rem; }
    .labour-page .modal-content { background:#fff; padding:1.25rem; border-radius:16px; width:95%; max-width:860px; max-height:90vh; overflow:auto; border:1px solid #dce7e1; box-shadow:0 28px 70px rgba(12,41,30,.24); }
    .labour-page .modal-header { display:flex; justify-content:space-between; align-items:center; margin-bottom:1rem; gap:1rem; }
    .labour-page .modal-title { font-size:1.25rem; font-weight:800; color:#17261f; }
    .labour-page .close-btn { background:none; border:none; font-size:1.5rem; cursor:pointer; color:#60756b; }
    .labour-page .form-grid { display:grid; grid-template-columns:repeat(2,1fr); gap:.85rem; }
    .labour-page .form-group { display:flex; flex-direction:column; }
    .labour-page .form-group label { margin-bottom:.35rem; font-weight:700; color:#385047; font-size:.86rem; }
    .labour-page .form-textarea { min-height:80px; resize:vertical; }
    .labour-page .hint { color:#72867d; font-size:.78rem; margin-top:.25rem; }
    .labour-page .list { max-height:420px; overflow:auto; border:1px solid #dce7e1; border-radius:10px; }
    .labour-page .list-row { padding:.75rem; border-bottom:1px solid #e8efeb; }
    .labour-page .list-row:last-child { border-bottom:none; }
    .labour-page .row-top { display:flex; gap:.75rem; align-items:center; justify-content:space-between; flex-wrap:wrap; }
    .labour-page .row-left { display:flex; gap:.5rem; align-items:center; flex-wrap:wrap; }
    .labour-page .tag { font-size:.75rem; color:#60756b; border:1px solid #dce7e1; border-radius:999px; padding:.15rem .55rem; background:#f7faf8; }
    .labour-page .pill-wrap { display:flex; flex-wrap:wrap; gap:.4rem; }
    .labour-page .pill { border:1px solid #cbd9d2; background:#fff; color:#385047; padding:.38rem .65rem; border-radius:999px; font-size:.84rem; cursor:pointer; user-select:none; }
    .labour-page .pill.on { color:#0f6d50; border-color:#168663; background:#eaf7f1; box-shadow:0 0 0 2px rgba(22,134,99,.1); }
    .labour-page .divider { height:1px; background:#e2ebe6; margin:.8rem 0; }
    @media (max-width:1200px) { .labour-page .cards { grid-template-columns:1fr 1fr; } .labour-page .chart-wrap { grid-column:1/-1; } .labour-page .filters { grid-template-columns:repeat(3,1fr); } }
    @media (max-width:720px) { .labour-page { padding-top:.5rem; } .labour-page .cards, .labour-page .filters, .labour-page .form-grid { grid-template-columns:1fr; } .labour-page .chart-wrap { grid-column:auto; } .labour-page .page-header .actions { width:100%; } .labour-page .page-header .actions .btn { flex:1; } }
  `}</style>
);

// --- helper to avoid sending empty/undefined to API ---
const clean = (src) => {
  const out = {};
  Object.entries(src).forEach(([k, v]) => {
    if (v === undefined || v === null || v === "" || v === "undefined" || v === "null") return;
    out[k] = v;
  });
  return out;
};

const toggleId = (arr, id) => {
  const n = Number(id);
  if (!Number.isFinite(n)) return arr;
  return arr.includes(n) ? arr.filter((x) => x !== n) : [...arr, n];
};

const toISODate = (v) => {
  if (!v) return "";
  if (typeof v === "string") return v.slice(0, 10);
  try {
    return new Date(v).toISOString().slice(0, 10);
  } catch {
    return "";
  }
};

const daysInclusive = (from, to) => {
  if (!from || !to) return 0;
  const a = new Date(`${from}T00:00:00`);
  const b = new Date(`${to}T00:00:00`);
  if (Number.isNaN(a.getTime()) || Number.isNaN(b.getTime())) return 0;
  const diff = Math.floor((b - a) / (1000 * 60 * 60 * 24));
  return diff >= 0 ? diff + 1 : 0;
};

const money = (n) => {
  const x = Number(n);
  if (!Number.isFinite(x)) return "-";
  return x.toLocaleString(undefined, { maximumFractionDigits: 2 });
};

const normalizeSalaryType = (t) => {
  const s = String(t || "").trim().toUpperCase();
  if (!s) return "";
  if (["DAILY", "WEEKLY", "MONTHLY"].includes(s)) return s;
  return "";
};

const salaryTypeLabel = (t) => {
  const s = normalizeSalaryType(t);
  if (!s) return "-";
  if (s === "DAILY") return "Daily";
  if (s === "WEEKLY") return "Weekly";
  if (s === "MONTHLY") return "Monthly";
  return s;
};

const derivePerDayFromTypeAndAmount = (salaryType, salaryAmount) => {
  const t = normalizeSalaryType(salaryType);
  const amt = Number(salaryAmount);
  if (!t || !Number.isFinite(amt) || amt <= 0) return null;

  if (t === "DAILY") return amt;
  if (t === "WEEKLY") return amt / 7;
  if (t === "MONTHLY") return amt / 30;
  return null;
};

// --- SVG Line chart from summary points (no libs) ---
const SummaryChart = ({ points = [] }) => {
  const width = 560,
    height = 160,
    padding = 24;
  const ys = points.map((p) => Number(p.totalSalary ?? p.totalAmount ?? p.totalCost ?? 0));
  const maxY = Math.max(1, ...ys);
  const scaleX = (i) => padding + (i * (width - 2 * padding)) / Math.max(1, ys.length - 1);
  const scaleY = (y) => height - padding - (y * (height - 2 * padding)) / maxY;
  const path = ys.length ? ys.map((y, i) => `${i === 0 ? "M" : "L"} ${scaleX(i)},${scaleY(y)}`).join(" ") : "";

  return (
    <div className="chart-wrap">
      <div className="chart-title">
        Summary
        <span className="legend">
          <span>
            <i className="dot" /> Total Salary
          </span>
        </span>
      </div>
      <svg viewBox={`0 0 ${width} ${height}`} width="100%" height={height} preserveAspectRatio="none" aria-label="Labour salary trend">
        <line x1={padding} y1={height - padding} x2={width - padding} y2={height - padding} stroke="#374151" />
        <line x1={padding} y1={padding} x2={padding} y2={height - padding} stroke="#374151" />
        <path d={path} fill="none" stroke="#9CA3AF" strokeWidth="2" />
        {ys.map((y, i) => (
          <circle key={i} cx={scaleX(i)} cy={scaleY(y)} r="3" fill="#9CA3AF" />
        ))}
      </svg>
      <div className="muted">Points: {points.length}</div>
    </div>
  );
};

const BatchPills = ({ batches = [], selectedIds = [], onToggle }) => (
  <div className="pill-wrap" style={{ marginTop: "0.25rem" }}>
    {batches.map((b) => {
      const bid = Number(b.id ?? b.value);
      const label = b.batchName ?? b.label ?? `Batch ${bid}`;
      const on = selectedIds.includes(bid);
      return (
        <span key={bid} className={`pill ${on ? "on" : ""}`} onClick={() => onToggle(bid)} title={label}>
          {label}
        </span>
      );
    })}
    {batches.length === 0 && <span className="muted">No batches available</span>}
  </div>
);

// ✅ Workers Modal (NOW includes salaryType + salaryAmount default for the worker)
const ManageWorkersModal = ({ isOpen, onClose, workers, onCreated, onUpdated, onDeleted }) => {
  const normName = (w) => (w?.name || w?.workerName || "").trim();

  const [list, setList] = useState([]);
  const [expandedId, setExpandedId] = useState(null);

  const [newW, setNewW] = useState({
    name: "",
    gender: "MALE",
    mobile: "",
    salaryType: "DAILY",
    salaryAmount: "",
    active: true,
    notes: "",
  });

  useEffect(() => {
    const normalized = (workers || []).map((w) => ({
      ...w,
      name: normName(w),
      active: w.active !== false,
      salaryType: normalizeSalaryType(w.salaryType) || "",
      salaryAmount: w.salaryAmount ?? "",
    }));
    setList(normalized);
  }, [workers]);

  if (!isOpen) return null;

  const create = async () => {
    if (!newW.name.trim()) return toast.error("Enter worker name");

    const payload = {
      name: newW.name.trim(),
      gender: newW.gender || "MALE",
      mobile: (newW.mobile || "").trim(),
      salaryType: normalizeSalaryType(newW.salaryType) || "DAILY",
      salaryAmount: newW.salaryAmount === "" ? null : Number(newW.salaryAmount),
      active: newW.active !== false,
      notes: newW.notes || "",
    };

    try {
      const created = await labourLogService.createWorker(payload);
      const createdNorm = {
        ...created,
        name: normName(created),
        active: created.active !== false,
        salaryType: normalizeSalaryType(created.salaryType) || "",
        salaryAmount: created.salaryAmount ?? "",
      };

      setList((prev) => [createdNorm, ...prev.filter((x) => x.id !== createdNorm.id)]);
      onCreated && onCreated(createdNorm);

      setNewW({
        name: "",
        gender: "MALE",
        mobile: "",
        salaryType: "DAILY",
        salaryAmount: "",
        active: true,
        notes: "",
      });
    } catch (e) {
      toast.error(labourLogService?._apiMsg?.(e) || e?.message || "Failed to add worker.");
    }
  };

  const setWorkerField = (id, key, value) => {
    setList((curr) => curr.map((w) => (w.id === id ? { ...w, [key]: value } : w)));
  };

  const update = async (id) => {
    const w = list.find((x) => x.id === id);
    if (!w) return;

    const payload = {
      name: (w.name || "").trim(),
      gender: w.gender || "MALE",
      mobile: (w.mobile || "").trim(),
      salaryType: normalizeSalaryType(w.salaryType) || "DAILY",
      salaryAmount: w.salaryAmount === "" ? null : Number(w.salaryAmount),
      active: w.active !== false,
      notes: w.notes || "",
    };

    try {
      const updated = await labourLogService.updateWorker(id, payload);
      const updatedNorm = {
        ...updated,
        name: normName(updated),
        active: updated.active !== false,
        salaryType: normalizeSalaryType(updated.salaryType) || "",
        salaryAmount: updated.salaryAmount ?? "",
      };

      setList((prev) => prev.map((x) => (x.id === id ? updatedNorm : x)));
      onUpdated && onUpdated(updatedNorm);
      setExpandedId(null);
    } catch (e) {
      toast.error(labourLogService?._apiMsg?.(e) || e?.message || "Failed to update worker.");
    }
  };

  // ✅ Delete → if backend fails (FK), mark inactive instead
  const remove = async (id) => {
    if (!window.confirm("Delete this worker?\nIf worker has logs, it will be marked INACTIVE instead.")) return;

    try {
      await labourLogService.deleteWorker(id);
      setList((prev) => prev.filter((w) => w.id !== id));
      onDeleted && onDeleted(id);
    } catch (e) {
      const serverMsg = e?.response?.data?.message || e?.response?.data?.error;

      // fallback: deactivate worker
      try {
        const w = list.find((x) => x.id === id);
        if (!w) throw e;

        const payload = {
          name: (w.name || "").trim(),
          gender: w.gender || "MALE",
          mobile: (w.mobile || "").trim(),
          salaryType: normalizeSalaryType(w.salaryType) || "DAILY",
          salaryAmount: w.salaryAmount === "" ? null : Number(w.salaryAmount),
          active: false,
          notes: w.notes || "",
        };

        const updated = await labourLogService.updateWorker(id, payload);
        const updatedNorm = {
          ...updated,
          name: normName(updated),
          active: updated.active !== false,
          salaryType: normalizeSalaryType(updated.salaryType) || "",
          salaryAmount: updated.salaryAmount ?? "",
        };

        setList((prev) => prev.map((x) => (x.id === id ? updatedNorm : x)));
        onUpdated && onUpdated(updatedNorm);

        toast.info((serverMsg ? serverMsg + "\n\n" : "") + "Worker cannot be deleted. Marked as INACTIVE instead.");
      } catch (fallbackErr) {
        toast.error(
          serverMsg ||
            fallbackErr?.response?.data?.message ||
            fallbackErr?.response?.data?.error ||
            fallbackErr?.message ||
            "Failed to delete worker."
        );
      }
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <div className="modal-header">
          <h2 className="modal-title">Workers</h2>
          <button onClick={onClose} className="close-btn" aria-label="Close">
            &times;
          </button>
        </div>

        {/* Create Worker */}
        <div className="card" style={{ marginBottom: "0.75rem" }}>
          <div className="muted" style={{ marginBottom: "0.5rem" }}>
            Labour ID will auto-generate after save. Salary defaults will be used for Work Logs if you don’t override them.
          </div>

          <div className="form-grid">
            <div className="form-group">
              <label>Name</label>
              <input className="input" value={newW.name} onChange={(e) => setNewW((s) => ({ ...s, name: e.target.value }))} />
            </div>

            <div className="form-group">
              <label>Gender</label>
              <select className="select" value={newW.gender} onChange={(e) => setNewW((s) => ({ ...s, gender: e.target.value }))}>
                <option value="MALE">Male</option>
                <option value="FEMALE">Female</option>
              </select>
            </div>

            <div className="form-group">
              <label>Mobile</label>
              <input className="input" value={newW.mobile} onChange={(e) => setNewW((s) => ({ ...s, mobile: e.target.value }))} placeholder="9876543210" />
            </div>

            <div className="form-group">
              <label>Active</label>
              <select className="select" value={newW.active ? "Yes" : "No"} onChange={(e) => setNewW((s) => ({ ...s, active: e.target.value === "Yes" }))}>
                <option value="Yes">Yes</option>
                <option value="No">No</option>
              </select>
            </div>

            {/* NEW: Worker default salary */}
            <div className="form-group">
              <label>Salary Type</label>
              <select className="select" value={newW.salaryType} onChange={(e) => setNewW((s) => ({ ...s, salaryType: e.target.value }))}>
                <option value="DAILY">Daily</option>
                <option value="WEEKLY">Weekly</option>
                <option value="MONTHLY">Monthly</option>
              </select>
              <div className="hint">Per-day is auto-derived: daily=amt, weekly=amt/7, monthly=amt/30</div>
            </div>

            <div className="form-group">
              <label>Salary Amount</label>
              <input
                className="input"
                type="number"
                step="0.01"
                value={newW.salaryAmount}
                onChange={(e) => setNewW((s) => ({ ...s, salaryAmount: e.target.value }))}
                placeholder="e.g., 600 / 3500 / 18000"
              />
            </div>

            <div className="form-group" style={{ gridColumn: "1 / -1" }}>
              <label>Notes</label>
              <textarea className="input form-textarea" value={newW.notes} onChange={(e) => setNewW((s) => ({ ...s, notes: e.target.value }))} />
            </div>
          </div>

          <div style={{ display: "flex", justifyContent: "flex-end", marginTop: "0.75rem" }}>
            <button className="btn btn-primary" onClick={create}>
              Add Worker
            </button>
          </div>
        </div>

        {/* Existing Workers */}
        <div className="list">
          {list.map((w) => {
            const open = expandedId === w.id;
            const labourId = w.labourId || "-";
            const activeTag = w.active !== false ? "Active" : "Inactive";
            const displayName = w.name || `Worker ${w.id}`;

            const perDayDerived = derivePerDayFromTypeAndAmount(w.salaryType, w.salaryAmount);

            return (
              <div key={w.id} className="list-row">
                <div className="row-top">
                  <div className="row-left">
                    <span className="tag" style={{ borderColor: "#4F46E5" }}>
                      {displayName}
                    </span>

                    <span className="tag">Labour ID: {labourId}</span>
                    <span className="tag">DB ID: {w.id}</span>
                    <span className="tag">{activeTag}</span>
                    {w.gender && <span className="tag">{String(w.gender).toUpperCase()}</span>}
                    {w.mobile && <span className="tag">{w.mobile}</span>}

                    {/* NEW salary tags */}
                    <span className="tag">Salary: {salaryTypeLabel(w.salaryType)} {w.salaryAmount !== "" && w.salaryAmount != null ? `₹${money(w.salaryAmount)}` : "-"}</span>
                    <span className="tag">Per-day: {perDayDerived == null ? "-" : `₹${money(perDayDerived)}`}</span>
                  </div>

                  <div style={{ display: "flex", gap: "0.5rem" }}>
                    <button className="btn btn-small" onClick={() => setExpandedId(open ? null : w.id)}>
                      {open ? "Close" : "Edit"}
                    </button>
                    <button className="btn btn-danger btn-small" onClick={() => remove(w.id)}>
                      Delete
                    </button>
                  </div>
                </div>

                {open && (
                  <>
                    <div className="divider" />
                    <div className="form-grid">
                      <div className="form-group">
                        <label>Name</label>
                        <input className="input" value={w.name || ""} onChange={(e) => setWorkerField(w.id, "name", e.target.value)} />
                      </div>

                      <div className="form-group">
                        <label>Gender</label>
                        <select className="select" value={w.gender || "MALE"} onChange={(e) => setWorkerField(w.id, "gender", e.target.value)}>
                          <option value="MALE">Male</option>
                          <option value="FEMALE">Female</option>
                        </select>
                      </div>

                      <div className="form-group">
                        <label>Mobile</label>
                        <input className="input" value={w.mobile || ""} onChange={(e) => setWorkerField(w.id, "mobile", e.target.value)} />
                      </div>

                      <div className="form-group">
                        <label>Active</label>
                        <select className="select" value={w.active !== false ? "Yes" : "No"} onChange={(e) => setWorkerField(w.id, "active", e.target.value === "Yes")}>
                          <option value="Yes">Yes</option>
                          <option value="No">No</option>
                        </select>
                      </div>

                      {/* NEW salary fields */}
                      <div className="form-group">
                        <label>Salary Type</label>
                        <select className="select" value={normalizeSalaryType(w.salaryType) || "DAILY"} onChange={(e) => setWorkerField(w.id, "salaryType", e.target.value)}>
                          <option value="DAILY">Daily</option>
                          <option value="WEEKLY">Weekly</option>
                          <option value="MONTHLY">Monthly</option>
                        </select>
                      </div>

                      <div className="form-group">
                        <label>Salary Amount</label>
                        <input
                          className="input"
                          type="number"
                          step="0.01"
                          value={w.salaryAmount ?? ""}
                          onChange={(e) => setWorkerField(w.id, "salaryAmount", e.target.value)}
                          placeholder="e.g., 600 / 3500 / 18000"
                        />
                      </div>

                      <div className="form-group" style={{ gridColumn: "1 / -1" }}>
                        <label>Notes</label>
                        <textarea className="input form-textarea" value={w.notes || ""} onChange={(e) => setWorkerField(w.id, "notes", e.target.value)} />
                      </div>

                      <div className="card" style={{ gridColumn: "1 / -1" }}>
                        <div className="muted">Per-day derived preview</div>
                        <div style={{ display: "flex", gap: "0.75rem", flexWrap: "wrap", marginTop: "0.35rem" }}>
                          <span className="tag">Salary Type: {salaryTypeLabel(w.salaryType)}</span>
                          <span className="tag">Salary Amount: {w.salaryAmount === "" || w.salaryAmount == null ? "-" : `₹${money(w.salaryAmount)}`}</span>
                          <span className="tag">Per-day: {perDayDerived == null ? "-" : `₹${money(perDayDerived)}`}</span>
                        </div>
                        <div className="hint" style={{ marginTop: "0.35rem" }}>
                          daily=amt, weekly=amt/7, monthly=amt/30
                        </div>
                      </div>
                    </div>

                    <div style={{ display: "flex", justifyContent: "flex-end", marginTop: "0.75rem", gap: "0.5rem" }}>
                      <button className="btn" onClick={() => update(w.id)}>
                        Save
                      </button>
                      <button className="btn btn-ghost" onClick={() => setExpandedId(null)}>
                        Cancel
                      </button>
                    </div>
                  </>
                )}
              </div>
            );
          })}
          {list.length === 0 && <div style={{ padding: "0.75rem", color: "#9CA3AF" }}>No workers yet.</div>}
        </div>
      </div>
    </div>
  );
};

// ✅ Work Log Modal (NOW includes leaveDays + derived per-day)
const WorkLogModal = ({ title, isOpen, onClose, onSave, workers, batches, initial }) => {
  const [form, setForm] = useState(null);

  const activeWorkers = useMemo(() => (workers || []).filter((w) => w.active !== false), [workers]);

  useEffect(() => {
    if (!isOpen) {
      setForm(null);
      return;
    }
    const init = initial || {};
    setForm({
      workerId: init.workerId ? String(init.workerId) : "",
      batchIds: Array.isArray(init.batchIds) ? init.batchIds.map(Number) : [],
      salaryType: normalizeSalaryType(init.salaryType) || "DAILY",
      fromDate: toISODate(init.fromDate || ""),
      toDate: toISODate(init.toDate || ""),
      salaryAmount: init.salaryAmount ?? "",
      perDaySalary: init.perDaySalary ?? "",
      leaveDays: init.leaveDays ?? 0,
      taskDone: init.taskDone || "",
      notes: init.notes || "",
    });
  }, [isOpen, initial]);

  // Autofill salaryType/salaryAmount from worker defaults (only when empty / new selection)
  useEffect(() => {
    if (!isOpen || !form) return;
    const wid = Number(form.workerId);
    if (!Number.isFinite(wid)) return;

    const w = (workers || []).find((x) => Number(x.id) === wid);
    if (!w) return;

    setForm((prev) => {
      // if user already typed something, don't overwrite
      const hasAmount = prev.salaryAmount !== "" && prev.salaryAmount != null;
      const hasPerDay = prev.perDaySalary !== "" && prev.perDaySalary != null;

      const next = { ...prev };

      if (!prev.salaryType && w.salaryType) next.salaryType = normalizeSalaryType(w.salaryType) || "DAILY";
      if (!hasAmount && w.salaryAmount != null) next.salaryAmount = w.salaryAmount;
      // don't auto-fill perDaySalary (keep as override field)
      if (!hasPerDay) next.perDaySalary = "";

      return next;
    });
    // eslint-disable-next-line
  }, [form?.workerId, isOpen]);

  if (!isOpen || !form) return null;

  const workDays = daysInclusive(form.fromDate, form.toDate);

  const leave = Number(form.leaveDays);
  const leaveDays = Number.isFinite(leave) && leave >= 0 ? Math.floor(leave) : 0;
  const payableDays = Math.max(0, workDays - leaveDays);

  const perDayOverride = Number(form.perDaySalary);
  const perDayDerived = derivePerDayFromTypeAndAmount(form.salaryType, form.salaryAmount);

  const perDayFinal = Number.isFinite(perDayOverride) && perDayOverride > 0 ? perDayOverride : perDayDerived;

  const deductionPreview = perDayFinal != null ? perDayFinal * Math.min(leaveDays, workDays) : 0;
  const totalPreview = perDayFinal != null ? perDayFinal * payableDays : 0;

  const payload = {
    workerId: form.workerId ? Number(form.workerId) : null,
    batchIds: form.batchIds,
    salaryType: normalizeSalaryType(form.salaryType) || null,
    fromDate: form.fromDate || null,
    toDate: form.toDate || null,

    // salary inputs
    salaryAmount: form.salaryAmount === "" ? null : Number(form.salaryAmount),
    perDaySalary: form.perDaySalary === "" ? null : Number(form.perDaySalary),

    // NEW
    leaveDays: leaveDays,

    taskDone: form.taskDone || "",
    notes: form.notes || "",
  };

  const submit = async (e) => {
    e.preventDefault();
    if (!payload.workerId) return toast.error("Select worker");
    if (!payload.fromDate || !payload.toDate) return toast.error("Select from/to date");
    if (workDays <= 0) return toast.error("To date must be same or after From date");
    if (!payload.taskDone.trim()) return toast.error("Enter task done");

    // if user didn't give perDaySalary override, ensure salaryAmount exists (so backend can derive)
    const hasOverride = payload.perDaySalary != null && Number.isFinite(payload.perDaySalary) && payload.perDaySalary > 0;
    const hasAmount = payload.salaryAmount != null && Number.isFinite(payload.salaryAmount) && payload.salaryAmount > 0;

    if (!hasOverride && !hasAmount) {
      return toast.error("Enter Salary Amount (or Per Day Salary override).");
    }

    await onSave(payload);
  };

  const selectedBatchLabels = (form.batchIds || [])
    .map((id) => {
      const b = (batches || []).find((x) => Number(x.id ?? x.value) === Number(id));
      return b?.batchName ?? b?.label ?? `Batch ${id}`;
    })
    .join(", ");

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <div className="modal-header">
          <h2 className="modal-title">{title}</h2>
          <button onClick={onClose} className="close-btn" aria-label="Close">
            &times;
          </button>
        </div>

        <form onSubmit={submit}>
          <div className="form-grid">
            <div className="form-group">
              <label>Worker</label>
              <select
                className="select"
                value={form.workerId}
                onChange={(e) => setForm((p) => ({ ...p, workerId: e.target.value }))}
                required
              >
                <option value="">Select worker</option>
                {activeWorkers.map((w) => {
                  const name = (w.name || w.workerName || "Unnamed").trim();
                  return (
                    <option key={w.id} value={w.id}>
                      {w.labourId ? `${w.labourId} - ` : ""}{name} {w.gender ? `(${w.gender})` : ""}
                    </option>
                  );
                })}
              </select>
              <div className="hint">If worker has default salary, it will auto-fill here.</div>
            </div>

            <div className="form-group">
              <label>Salary Type</label>
              <select className="select" value={form.salaryType} onChange={(e) => setForm((p) => ({ ...p, salaryType: e.target.value }))}>
                <option value="DAILY">Daily</option>
                <option value="WEEKLY">Weekly</option>
                <option value="MONTHLY">Monthly</option>
              </select>
              <div className="hint">Per-day derived: daily=amt, weekly=amt/7, monthly=amt/30</div>
            </div>

            <div className="form-group">
              <label>From Date</label>
              <input className="input" type="date" value={form.fromDate} onChange={(e) => setForm((p) => ({ ...p, fromDate: e.target.value }))} required />
            </div>

            <div className="form-group">
              <label>To Date</label>
              <input className="input" type="date" value={form.toDate} onChange={(e) => setForm((p) => ({ ...p, toDate: e.target.value }))} required />
            </div>

            <div className="form-group">
              <label>Salary Amount (as per Salary Type)</label>
              <input
                className="input"
                type="number"
                step="0.01"
                value={form.salaryAmount}
                onChange={(e) => setForm((p) => ({ ...p, salaryAmount: e.target.value }))}
                placeholder="Daily/Weekly/Monthly amount"
              />
              <div className="hint">
                Example: DAILY=600, WEEKLY=3500, MONTHLY=18000
              </div>
            </div>

            <div className="form-group">
              <label>Per Day Salary (Override - optional)</label>
              <input
                className="input"
                type="number"
                step="0.01"
                value={form.perDaySalary}
                onChange={(e) => setForm((p) => ({ ...p, perDaySalary: e.target.value }))}
                placeholder="If you want exact per-day"
              />
              <div className="hint">If filled, this will override auto-derived per-day.</div>
            </div>

            {/* NEW: Leave Days */}
            <div className="form-group">
              <label>Leave Days</label>
              <input
                className="input"
                type="number"
                min="0"
                step="1"
                value={form.leaveDays}
                onChange={(e) => setForm((p) => ({ ...p, leaveDays: e.target.value }))}
                placeholder="0"
              />
              <div className="hint">Deduction = per-day × leaveDays</div>
            </div>

            <div className="form-group" style={{ gridColumn: "1 / -1" }}>
              <label>Batch Worked (Multi)</label>
              <BatchPills batches={batches || []} selectedIds={form.batchIds} onToggle={(bid) => setForm((p) => ({ ...p, batchIds: toggleId(p.batchIds, bid) }))} />
              <div className="hint">Selected: {selectedBatchLabels || "None"}</div>
            </div>

            <div className="form-group" style={{ gridColumn: "1 / -1" }}>
              <label>Task Done</label>
              <input className="input" value={form.taskDone} onChange={(e) => setForm((p) => ({ ...p, taskDone: e.target.value }))} placeholder="e.g., cleaning, feeding, vaccination help..." />
            </div>

            <div className="form-group" style={{ gridColumn: "1 / -1" }}>
              <label>Notes</label>
              <textarea className="input form-textarea" value={form.notes} onChange={(e) => setForm((p) => ({ ...p, notes: e.target.value }))} />
            </div>

            {/* Preview */}
            <div className="card" style={{ gridColumn: "1 / -1" }}>
              <div className="muted">Auto Calculation Preview</div>
              <div style={{ display: "flex", gap: "0.75rem", flexWrap: "wrap", marginTop: "0.35rem" }}>
                <span className="tag">Working Days: {workDays || 0}</span>
                <span className="tag">Leave Days: {leaveDays}</span>
                <span className="tag">Payable Days: {payableDays}</span>
                <span className="tag">Per-day: {perDayFinal == null ? "-" : `₹${money(perDayFinal)}`}</span>
                <span className="tag">Deduction: {perDayFinal == null ? "-" : `₹${money(deductionPreview)}`}</span>
                <span className="tag">Total: {perDayFinal == null ? "-" : `₹${money(totalPreview)}`}</span>
              </div>
              <div className="hint" style={{ marginTop: "0.35rem" }}>
                Backend will calculate and store: perDaySalary, daysWorked, leaveDays, payableDays, deduction, totalSalary.
              </div>
            </div>
          </div>

          <div style={{ display: "flex", justifyContent: "flex-end", gap: "0.5rem", marginTop: "0.75rem" }}>
            <button type="button" onClick={onClose} className="btn btn-ghost">
              Cancel
            </button>
            <button type="submit" className="btn btn-primary">
              Save
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

// --- Main Component ---
export default function LabourManagementPage() {
  const [logs, setLogs] = useState([]);
  const [pageData, setPageData] = useState({ totalElements: 0, totalPages: 0, number: 0, size: 20 });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const [addOpen, setAddOpen] = useState(false);
  const [manageWorkersOpen, setManageWorkersOpen] = useState(false);

  // edit log state
  const [editLog, setEditLog] = useState(null);
  const [editOpen, setEditOpen] = useState(false);

  const [workers, setWorkers] = useState([]);
  const [batches, setBatches] = useState([]);

  const apiMsg = (e) =>
    labourLogService?._apiMsg?.(e) ||
    e?.response?.data?.message ||
    e?.response?.data?.error ||
    (typeof e?.response?.data === "string" ? e.response.data : null) ||
    e?.message ||
    "Request failed";

  const [filters, setFilters] = useState({
    workerName: "",
    taskDone: "",
    batchId: "",
    salaryType: "",
    fromDate: "",
    toDate: "",
    page: 0,
    size: 20,
    sort: "fromDate,desc",
  });

  // Optional KPIs
  const [monthlyTotal, setMonthlyTotal] = useState(null);
  const [summary, setSummary] = useState([]);
  const [groupBy, setGroupBy] = useState("weekly");
  const [summaryRange, setSummaryRange] = useState(() => {
    const to = new Date();
    const from = new Date();
    from.setDate(to.getDate() - 28);
    return { from: from.toISOString().slice(0, 10), to: to.toISOString().slice(0, 10) };
  });

  // Load dropdowns once
  useEffect(() => {
    (async () => {
      try {
        const [w, b] = await Promise.all([labourLogService.getWorkers(), labourLogService.getBatches()]);
        setWorkers(w || []);
        setBatches(b || []);
      } catch (e) {
        console.error(e);
        setError(apiMsg(e));
      }
    })();
    // eslint-disable-next-line
  }, []);

  const loadWorkers = async () => {
    try {
      const w = await labourLogService.getWorkers();
      setWorkers(w || []);
    } catch (e) {
      console.error(e);
      toast.error(apiMsg(e));
    }
  };

  // Load table with filters
  const loadLogs = async () => {
    setLoading(true);
    setError("");
    try {
      const page = await labourLogService.getAllLabourLogs(clean(filters));
      setLogs(page.content || []);
      setPageData({
        totalElements: page.totalElements ?? (page.content?.length || 0),
        totalPages: page.totalPages ?? 1,
        number: page.number ?? 0,
        size: page.size ?? filters.size,
      });
    } catch (e) {
      console.error(e);
      setError(apiMsg(e));
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadLogs(); // eslint-disable-next-line
  }, [filters.page, filters.size, filters.sort]);

  const loadMonthlyTotal = async () => {
    if (typeof labourLogService.getMonthlyTotal !== "function") return;
    const now = new Date();
    const month = now.getMonth() + 1;
    const year = now.getFullYear();
    try {
      const total = await labourLogService.getMonthlyTotal(month, year);
      setMonthlyTotal(total);
    } catch (e) {
      console.error("Monthly total error", e);
    }
  };

  const loadSummary = async () => {
    if (typeof labourLogService.getSummary !== "function") return;
    try {
      const data = await labourLogService.getSummary(summaryRange.from, summaryRange.to, groupBy);
      setSummary(data || []);
    } catch (e) {
      console.error("Summary error", e);
    }
  };

  useEffect(() => {
    loadMonthlyTotal();
    loadSummary(); // eslint-disable-next-line
  }, []);

  useEffect(() => {
    loadSummary(); // eslint-disable-next-line
  }, [groupBy]);

  const handleApplyFilters = () => {
    setFilters((prev) => ({ ...prev, page: 0 }));
    loadLogs();
  };

  const handleSaveLog = async (dto) => {
    try {
      await labourLogService.addLabourLog(dto);
      setAddOpen(false);
      await Promise.all([loadLogs(), loadMonthlyTotal(), loadSummary()]);
    } catch (err) {
      console.error(err);
      toast.error(apiMsg(err));
    }
  };

  const handleUpdateLog = async (payload) => {
    try {
      await labourLogService.updateLabourLog(editLog.id, payload);
      setEditOpen(false);
      setEditLog(null);
      await Promise.all([loadLogs(), loadMonthlyTotal(), loadSummary()]);
    } catch (e) {
      console.error(e);
      toast.error(apiMsg(e));
    }
  };

  const handleDeleteLog = async (id) => {
    if (!window.confirm("Delete this work log?")) return;
    try {
      await labourLogService.deleteLabourLog(id);
      await Promise.all([loadLogs(), loadMonthlyTotal(), loadSummary()]);
    } catch (e) {
      console.error(e);
      toast.error(apiMsg(e));
    }
  };

  const exportCsv = async () => {
    if (typeof labourLogService.exportCsv !== "function") {
      toast.error("Export is not enabled in your API service yet.");
      return;
    }
    await labourLogService.exportCsv(clean(filters));
  };

  // Worker modal callbacks
  const onWorkerCreated = (w) => setWorkers((prev) => [...prev, w]);
  const onWorkerUpdated = (w) => setWorkers((prev) => prev.map((x) => (x.id === w.id ? w : x)));
  const onWorkerDeleted = (id) => setWorkers((prev) => prev.filter((x) => x.id !== id));

  const batchNameFromId = (id) => {
    const b = (batches || []).find((x) => Number(x.id ?? x.value) === Number(id));
    return b?.batchName ?? b?.label ?? `Batch ${id}`;
  };

  const renderBatchesForLog = (log) => {
    if (Array.isArray(log.batchNames) && log.batchNames.length) return log.batchNames.join(", ");
    if (Array.isArray(log.batches) && log.batches.length) {
      return log.batches.map((b) => b.batchName ?? b.name ?? batchNameFromId(b.id)).join(", ");
    }
    if (Array.isArray(log.batchIds) && log.batchIds.length) {
      return log.batchIds.map((id) => batchNameFromId(id)).join(", ");
    }
    return "";
  };

  return (
    <div className="labour-page">
      <Styles />

      <div className="page-header">
        <h1 className="page-title">Labour Work Logs</h1>
        <div className="actions">
          <button onClick={() => setAddOpen(true)} className="btn btn-primary">
            Add Work Log
          </button>
          <button
            onClick={async () => {
              await loadWorkers();
              setManageWorkersOpen(true);
            }}
            className="btn"
          >
            Manage Workers
          </button>
          <button onClick={exportCsv} className="btn">
            Export CSV
          </button>
        </div>
      </div>

      {error && <div className="error-message">{error}</div>}

      {(typeof labourLogService.getMonthlyTotal === "function" || typeof labourLogService.getSummary === "function") && (
        <div className="cards">
          <div className="card">
            <div className="muted">Total Salary (This Month)</div>
            <div className="kpi">
              {monthlyTotal == null ? "-" : typeof monthlyTotal === "number" ? monthlyTotal.toLocaleString() : monthlyTotal}
            </div>
          </div>

          <div className="card">
            <div className="muted">Summary Range</div>
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "0.5rem", marginTop: "0.3rem" }}>
              <input type="date" className="input" value={summaryRange.from} onChange={(e) => setSummaryRange((r) => ({ ...r, from: e.target.value }))} />
              <input type="date" className="input" value={summaryRange.to} onChange={(e) => setSummaryRange((r) => ({ ...r, to: e.target.value }))} />
            </div>
            <div style={{ display: "flex", gap: "0.5rem", marginTop: "0.5rem" }}>
              <select className="select" value={groupBy} onChange={(e) => setGroupBy(e.target.value)}>
                <option value="daily">Daily</option>
                <option value="weekly">Weekly</option>
              </select>
              <button className="btn" onClick={loadSummary}>
                Apply
              </button>
            </div>
          </div>

          <SummaryChart points={summary} />
        </div>
      )}

      {/* Filters */}
      <div className="filters">
        <input className="input" placeholder="Worker name" value={filters.workerName} onChange={(e) => setFilters((p) => ({ ...p, workerName: e.target.value }))} />
        <input className="input" placeholder="Task done" value={filters.taskDone} onChange={(e) => setFilters((p) => ({ ...p, taskDone: e.target.value }))} />

        <select className="select" value={filters.batchId} onChange={(e) => setFilters((p) => ({ ...p, batchId: e.target.value }))}>
          <option value="">All Batches</option>
          {(batches || []).map((b) => (
            <option key={b.id ?? b.value} value={b.id ?? b.value}>
              {b.batchName ?? b.label}
            </option>
          ))}
        </select>

        <select className="select" value={filters.salaryType} onChange={(e) => setFilters((p) => ({ ...p, salaryType: e.target.value }))}>
          <option value="">All Salary Types</option>
          <option value="DAILY">Daily</option>
          <option value="WEEKLY">Weekly</option>
          <option value="MONTHLY">Monthly</option>
        </select>

        <input className="input" type="date" value={filters.fromDate} onChange={(e) => setFilters((p) => ({ ...p, fromDate: e.target.value }))} />
        <input className="input" type="date" value={filters.toDate} onChange={(e) => setFilters((p) => ({ ...p, toDate: e.target.value }))} />

        <div style={{ display: "flex", gap: "0.5rem", gridColumn: "1 / -1" }}>
          <button className="btn" onClick={handleApplyFilters}>
            Apply
          </button>
          <button
            className="btn"
            onClick={() => {
              setFilters({
                workerName: "",
                taskDone: "",
                batchId: "",
                salaryType: "",
                fromDate: "",
                toDate: "",
                page: 0,
                size: 20,
                sort: "fromDate,desc",
              });
              loadLogs();
            }}
          >
            Reset
          </button>
        </div>
      </div>

      {/* Table */}
      <div className="table-container">
        <table className="labour-table">
          <thead>
            <tr>
              <th>From</th>
              <th>To</th>
              <th>Worker</th>
              <th>Salary Type</th>
              <th>Batches</th>
              <th>Per Day</th>
              <th>Days</th>
              <th>Leave</th>
              <th>Payable</th>
              <th>Deduction</th>
              <th>Total</th>
              <th>Task Done</th>
              <th>Notes</th>
              <th>Actions</th>
            </tr>
          </thead>

          <tbody>
            {loading ? (
              <tr>
                <td colSpan="14" style={{ textAlign: "center" }}>
                  Loading...
                </td>
              </tr>
            ) : logs.length === 0 ? (
              <tr>
                <td colSpan="14" style={{ textAlign: "center", color: "#9CA3AF" }}>
                  No logs found
                </td>
              </tr>
            ) : (
              logs.map((log) => {
                const from = toISODate(log.fromDate || "");
                const to = toISODate(log.toDate || "");

                const workerName = (log.workerName || log.worker?.name || "-").trim();
                const workerId = log.workerId ?? log.worker?.id ?? null;

                const labourId = workerId ? (workers || []).find((w) => w.id === workerId)?.labourId : "";

                const salaryType = log.salaryType ?? "";
                const perDaySalary = log.perDaySalary ?? null;

                const daysWorked = log.daysWorked ?? daysInclusive(from, to);
                const leaveDays = log.leaveDays ?? 0;
                const payableDays = log.payableDays ?? Math.max(0, (daysWorked || 0) - (leaveDays || 0));
                const deduction = log.deduction ?? null;

                const totalSalary = log.totalSalary ?? null;

                const taskDone = log.taskDone ?? "";
                const notes = log.notes ?? "";

                const batchesText = renderBatchesForLog(log);

                return (
                  <tr key={log.id}>
                    <td>{from || "-"}</td>
                    <td>{to || "-"}</td>
                    <td>
                      <div style={{ display: "flex", flexDirection: "column", gap: "0.15rem" }}>
                        <span>
                          {labourId ? `${labourId} - ` : ""}
                          {workerName}
                        </span>
                      </div>
                    </td>
                    <td>{salaryTypeLabel(salaryType)}</td>
                    <td style={{ maxWidth: 320, whiteSpace: "normal" }}>{batchesText}</td>
                    <td>{perDaySalary == null ? "-" : `₹${money(perDaySalary)}`}</td>
                    <td>{daysWorked ?? "-"}</td>
                    <td>{leaveDays ?? 0}</td>
                    <td>{payableDays ?? "-"}</td>
                    <td>{deduction == null ? "-" : `₹${money(deduction)}`}</td>
                    <td>{totalSalary == null ? "-" : `₹${money(totalSalary)}`}</td>
                    <td style={{ maxWidth: 260, whiteSpace: "normal" }}>{taskDone}</td>
                    <td style={{ maxWidth: 260, whiteSpace: "normal" }}>{notes}</td>
                    <td>
                      <div className="actions">
                        <button
                          className="btn btn-small"
                          onClick={() => {
                            setEditLog({
                              ...log,
                              workerId: workerId ?? null,
                              batchIds: log.batchIds ?? (log.batches ? log.batches.map((b) => b.id) : []),
                              fromDate: from,
                              toDate: to,
                              salaryType: normalizeSalaryType(log.salaryType) || "DAILY",
                              salaryAmount: log.salaryAmount ?? "",
                              perDaySalary: log.perDaySalary ?? "",
                              leaveDays: log.leaveDays ?? 0,
                            });
                            setEditOpen(true);
                          }}
                        >
                          Edit
                        </button>
                        <button className="btn btn-danger btn-small" onClick={() => handleDeleteLog(log.id)}>
                          Delete
                        </button>
                      </div>
                    </td>
                  </tr>
                );
              })
            )}
          </tbody>
        </table>
      </div>

      {/* Pagination */}
      <div style={{ display: "flex", justifyContent: "flex-end", gap: "0.5rem", marginTop: "0.6rem" }}>
        <button className="btn" disabled={pageData.number <= 0} onClick={() => setFilters((p) => ({ ...p, page: Math.max(0, p.page - 1) }))}>
          Prev
        </button>
        <div className="muted" style={{ alignSelf: "center" }}>
          Page {pageData.number + 1} / {Math.max(1, pageData.totalPages)}
        </div>
        <button className="btn" disabled={pageData.number >= pageData.totalPages - 1} onClick={() => setFilters((p) => ({ ...p, page: p.page + 1 }))}>
          Next
        </button>
      </div>

      {/* Modals */}
      <WorkLogModal title="Add Work Log" isOpen={addOpen} onClose={() => setAddOpen(false)} onSave={handleSaveLog} workers={workers} batches={batches} />

      <WorkLogModal
        title="Edit Work Log"
        isOpen={editOpen}
        onClose={() => {
          setEditOpen(false);
          setEditLog(null);
        }}
        onSave={handleUpdateLog}
        workers={workers}
        batches={batches}
        initial={editLog}
      />

      <ManageWorkersModal
        isOpen={manageWorkersOpen}
        onClose={() => setManageWorkersOpen(false)}
        workers={workers}
        onCreated={onWorkerCreated}
        onUpdated={onWorkerUpdated}
        onDeleted={onWorkerDeleted}
      />
    </div>
  );
}
